import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import MasterDetailsReport from '../../../../common/components/MasterDetailsReport';
import Report from '../../../../common/components/Report';

const PredesComplianceMissingMandatoryElementsReport = props => (
  <Report
    tabs={[
      {
        value: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_SUMMARY.id,
        label: 'SUMMARY',
      },
      {
        value: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_ERROR_MESSAGES.id,
        label: 'ERROR MESSAGES',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
      {
        value: ReportDefinitions.PREDES_COMPLIANCE_MISSING_MANDATORY_ELEMENTS_KEY_DETAILS.id,
        label: 'KEY DETAILS',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.type.c.reports',
      },
    ]
    }
    {...props}
  />
);
export default PredesComplianceMissingMandatoryElementsReport;

PredesComplianceMissingMandatoryElementsReport.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
  masterDetailsReport: PropTypes.instanceOf(MasterDetailsReport),
  modeTabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string, label: PropTypes.string,
  })),
  mode: PropTypes.string,
  changeMode: PropTypes.func,
};
